
//16
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "DropdownOption1533373717",
    {"root":"DropdownOption1533373717--root","highlight":"DropdownOption1533373717--highlight","nonHighlight":"DropdownOption1533373717--nonHighlight","hoverBackgroundColor":"lightgrey","selectedBackgroundColor":"grey","selectedHoverBackgroundColor":"dimgrey","disabledBackgroundColor":"white"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/dropdown-option/DropdownOption.st.css
// module id = 303
// module chunks = 0